import { Injectable } from '@angular/core';
declare global {
 interface Window { dataLayer: any[]; }
}
@Injectable({ providedIn: 'root' })
export class GtmService {
    
constructor() {
}

    pushUserData(user: any) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'user_data',
        user_id: user.id,
        user_logged: 'yes',
        user_email: user.email,
        user_birthdate: user.birthdate,
        user_gender: user.gender,
        user_creationdate: user.creationDate,
        user_plan: user.plan,
        user_aov: user.aov,
        user_totalorders: user.totalOrders,
        user_totalspent: user.totalSpent,
        user_total_products_purchased: user.totalProducts,
        user_totalMonthsPurchased: user.totalMonths,
        user_consults: user.consults,
        user_requestsCareManager: user.requestsCareManager,
        user_lastorder_date: user.lastOrderDate,
        user_repeater: user.repeater,
        page_type: 'corporate',
        page_language: 'it',
        currency: 'EUR',
        user_hashed_email: user.hashedEmail,
        user_phone: user.phone,
        user_first_name: user.firstName,
        user_last_name: user.lastName,
        user_street: user.street,
        user_city: user.city,
        user_region: user.region,
        user_country: user.country,
        user_postal_code: user.postalCode,
      });
    }

    pushLoginEvent(method: 'Google' | 'Sito' | 'Codice') {
      window.dataLayer.push({
        event: 'login',
        method
      });
    }

    pushLogoutEvent() {
      window.dataLayer.push({
        event: 'logout'
      });
    }

    pushActivationCodeEvent(step: string, registeredUser: boolean) {
      window.dataLayer.push({
        event: 'activation_code',
        step, 
        registered_user: registeredUser ? 'yes' : 'no'
      });
    }

    pushUpdateUserEvent(step: string) {
      window.dataLayer.push({
        event: 'update_user_data',
        step
      });
    }

    pushConsultEvent(eventData: Record<string, any>): void {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(eventData);
    }
    
    pushSymptomAssessmentEvent(step: string) {
      window.dataLayer.push({
        event: 'symptom_assessment',
        step
      });
    }
    
    pushHealthDataEvent(event: string, data_type: string) {
      window.dataLayer.push({
        event,
        data_type
      });
    }

    pushDeliveryDataEvent(delivery_type: string) {
      window.dataLayer.push({
        event: 'delivery_medicines',
        delivery_type
      });
    }

    pushFindStructureEvent() {
      window.dataLayer.push({
        event: 'find_structure'
      });
    }

    pushStartConsultation(item_name: String){
      window.dataLayer.push({
        event: 'consultation_start',
        item_name
      });
    }

    pushAngularVirtualPv(path: string) {
      const lang = localStorage.getItem('lang') || 'it';
      const locale = lang === 'en' ? 'en-GB' : 'it-IT';
      window.dataLayer.push({
        event: 'angular-virtualPV',
        path,
        locale
      });
    }

    pushVirtualPage(pageTitle: string, pagePath: string) {
      window.dataLayer = window.dataLayer || [];
      const payload = {
        event: 'virtual_page',
        page_path: pagePath,
        page_title: pageTitle
      }
      window.dataLayer.push(payload);
    }

    pushSubscribeClickEvent(type: string | undefined) {
      window.dataLayer.push({
        event: 'click_subscribe',
        subscribtion_type: type
      });
    }
}